import React from 'react';
import { Waves, Droplet, X } from 'lucide-react';
import { BalneotherapyType, BALNEOTHERAPY_TARIFFS } from '../../types';

interface BalneotherapySelectorProps {
  value: BalneotherapyType;
  onChange: (value: BalneotherapyType) => void;
  darkMode: boolean;
  displayQuantity: number;
}

const BalneotherapySelector: React.FC<BalneotherapySelectorProps> = ({ value, onChange, darkMode, displayQuantity }) => {
  const handleToggle = (type: BalneotherapyType) => { onChange(value === type ? 'none' : type); };
  const poolTariff = { current: BALNEOTHERAPY_TARIFFS[2025].pool, future: BALNEOTHERAPY_TARIFFS[2026].pool };
  const basinTariff = { current: BALNEOTHERAPY_TARIFFS[2025].basin, future: BALNEOTHERAPY_TARIFFS[2026].basin };

  const getSupplementAmount = () => {
    if (value === 'none') return 0;
    return (value === 'pool' ? poolTariff.current : basinTariff.current) * displayQuantity;
  };
  const supplementAmount = getSupplementAmount();

  const selectedClass = (active: boolean) => active
    ? 'bg-appines-glass/25 border-appines-emerald text-appines-petrol'
    : darkMode
      ? 'bg-appines-white/10 border-appines-white/20 text-appines-white/65 hover:border-appines-white/30'
      : 'bg-[rgba(1,42,54,0.04)] border-[rgba(1,42,54,0.2)] text-appines-petrol/65 hover:border-[rgba(1,42,54,0.3)]';

  return (
    <div className="flex flex-col items-center space-y-2">
      <div className="flex space-x-2">
        <button onClick={() => handleToggle('pool')}
          className={`flex flex-col items-center justify-center px-3 py-2 rounded-lg border-2 transition-all ${selectedClass(value === 'pool')}`}
          title={`Piscine: ${poolTariff.current}€ (2025) → ${poolTariff.future}€ (2026+)`}>
          <Waves className="h-5 w-5 mb-1" /><span className="text-xs">Piscine</span>
        </button>
        <button onClick={() => handleToggle('basin')}
          className={`flex flex-col items-center justify-center px-3 py-2 rounded-lg border-2 transition-all ${selectedClass(value === 'basin')}`}
          title={`Bassin: ${basinTariff.current}€ (2025) → ${basinTariff.future}€ (2026+)`}>
          <Droplet className="h-5 w-5 mb-1" /><span className="text-xs">Bassin</span>
        </button>
        {value !== 'none' && (
          <button onClick={() => onChange('none')}
            className={`flex items-center justify-center px-2 py-2 rounded-lg border-2 transition-all ${darkMode ? 'bg-appines-petal/15 border-appines-petal/40 text-appines-petal hover:bg-appines-petal/25' : 'bg-appines-petal/10 border-appines-petal/30 text-[#c04040] hover:bg-appines-petal/20'}`}
            title="Supprimer le supplément balnéothérapie">
            <X className="h-5 w-5" />
          </button>
        )}
      </div>
      {supplementAmount > 0 && (
        <div className="text-xs text-center text-appines-emerald">+{supplementAmount.toFixed(2)}€</div>
      )}
    </div>
  );
};

export default BalneotherapySelector;
